import React from "react";

import { Box } from "@chakra-ui/react";

import { BusinessTransactionsTable } from "./BusinessTransactionsTable";

export const BusinessTransactions = () => {
  return (
    <Box className="mt-1">
      <BusinessTransactionsTable />
    </Box>
  );
};
